<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('classAttendance.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('classAttendance.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-loading-banner :loading="loadingPreData">
      <ts-card>
        <ts-card-wrapper>
          <form class="form-horizontal">
            <fieldset>
              <legend class="text-black">
                {{ $t('classAttendance.selectCriterial') }}
              </legend>
              <div class="row">
                <div class="col-sm-12 col-lg-3 col-md-6">
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label required"
                      >{{ $t('classAttendance.date') }}</label
                    >
                    <div class="col-md-8">
                      <ts-date-picker-input
                        v-model="model.att_date"
                      ></ts-date-picker-input>
                      <div class="validate" v-if="errors.has('att_date')">
                        {{ errors.first('att_date') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-4 col-md-6">
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label required"
                      >{{ $t('classAttendance.termName') }}</label
                    >
                    <div class="col-md-8">
                      <treeselect
                        :load-options="loadTerms"
                        :options="termOptions"
                        :placeholder="$t('typeForSearch')"
                        v-model="model.ac_term_id"
                      />
                      <div class="validate" v-if="errors.has('ac_term_id')">
                        {{ errors.first('ac_term_id') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-4 col-md-6">
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label required"
                      >{{ $t('classAttendance.className') }}</label
                    >
                    <div class="col-md-8">
                      <treeselect
                        :load-options="loadClasses"
                        :options="classOptions"
                        :placeholder="$t('typeForSearch')"
                        v-model="model.class_id"
                      />
                      <div class="validate" v-if="errors.has('class_id')">
                        {{ errors.first('class_id') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-lg-3 col-md-6">
                  <div class="form-group row">
                    <label class="col-md-4 form-col-label control-label">{{
                      $t('classAttendance.teacherName')
                    }}</label>
                    <div class="col-md-8">
                      <ts-loading-banner :loading="fetchingTeacher">
                        <select
                          v-model.number="model.teacher_id"
                          class="form-control"
                        >
                          <option :value="null">{{ $t('select') }}</option>
                          <option
                            v-for="(teacher, index) in teacherOrSubjects"
                            :key="index"
                            :value="teacher.teacher_id"
                            >{{ teacher.teacher_name }}</option
                            >
                        </select>
                      </ts-loading-banner>
                    </div>
                  </div>
                </div>
                <div
                  class="col-sm-12 col-lg-4 col-md-6"
                  v-show="att_by_subject != 0"
                >
                  <div class="form-group row">
                    <label class="col-md-4 form-col-label control-label">{{
                      $t('classAttendance.subjectName')
                    }}</label>
                    <div class="col-md-8">
                      <ts-loading-banner :loading="fetchingTeacher">
                        <select
                          v-model.number="model.subject_id"
                          class="form-control"
                        >
                          <option :value="null">{{ $t('select') }}</option>
                          <option
                            v-for="(subject, index) in teacherOrSubjects"
                            :key="index"
                            :value="subject.subject_id"
                            >{{ subject.subject_name }}</option
                            >
                        </select>
                      </ts-loading-banner>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-4 col-md-6">
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label"
                    ></label>
                    <div class="col-md-8">
                      <ts-button
                        @click="fetchData"
                        color="info"
                        outline
                        :waiting="loading"
                        >{{ $t('search') }}</ts-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </ts-card-wrapper>
        <div class="overflow-auto">
          <div id="table-container">
            <ts-table
              :columns="columns"
              :records="model.student_attendance_list"
              :loading="loading"
            >
              <template slot-scope="{ record }">
                <td class="ts-whitespace-no-wrap">{{ record.student_name }}</td>
                <td class="ts-whitespace-no-wrap">
                  <div
                    v-for="(att, index) in attendenStatus"
                    :key="index"
                    class="radio radio-css radio-inline"
                  >
                    <input
                      type="radio"
                      :id="[index] + 'att_status_id' + [record.student_id]"
                      v-model="record['att_status_id']"
                      :value="att.att_status_id"
                      :checked="
                        record.att_status_id == att.att_status_id ? true : false
                      "
                    />
                    <label
                      :for="[index] + 'att_status_id' + [record.student_id]"
                      >{{ att.att_status }}</label
                    >
                  </div>
                </td>
                <td class="ts-whitespace-no-wrap">
                  <div
                    v-for="(pre, index) in presentStatus"
                    :key="index"
                    class="radio radio-css radio-inline"
                    v-show="record.att_status_id == 1 ? true : false"
                  >
                    <input
                      type="radio"
                      :id="[index] + 'present_status_id' + [record.student_id]"
                      v-model="record['present_status_id']"
                      :value="
                        record.att_status_id != 1
                          ? (record.present_status_id = null)
                          : pre.present_status_id
                      "
                      :checked="
                        record.present_status_id === pre.present_status_id
                          ? true
                          : false
                      "
                    />
                    <label
                      :for="[index] + 'present_status_id' + [record.student_id]"
                      >{{ pre.present_status }}</label
                    >
                  </div>
                </td>
                <td class="ts-whitespace-no-wrap">
                  <input
                    type="text"
                    v-model="record.comments"
                    class="form-control only-border-bottom"
                  />
                </td>
              </template>
            </ts-table>
          </div>
        </div>
        <hr />
        <ts-card-wrapper>
          <div class="text-right">
            <ts-button
              @click="save"
              color="primary"
              :disabled="model.student_attendance_list.length <= 0"
              :waiting="saving"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </ts-card-wrapper>
      </ts-card>
    </ts-loading-banner>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import { debounce } from 'lodash'

export default {
  name: 'classAttendance',
  data () {
    const newModel = {
      att_date: moment().format('DD-MM-YYYY'),
      ac_term_id: null,
      class_id: null,
      teacher_id: null,
      subject_id: null,
      student_attendance_list: []
    }

    return {
      loading: false,
      saving: false,
      newModel: newModel,
      model: _.cloneDeep(newModel),
      termOptions: null,
      classOptions: null,
      fetchingTeacher: false,
      loadingPreData: false,
      errors: new Errors(),
      branch_id: []
    }
  },
  computed: {
    ...mapState('classAttendance', [
      'teacherOrSubjects',
      'att_by_subject',
      'attendenStatus',
      'presentStatus'
    ]),
    columns () {
      return [
        { name: this.$t('classAttendance.studentName') },
        { name: this.$t('classAttendance.attendanceStatus') },
        { name: this.$t('classAttendance.presentStatus') },
        { name: this.$t('classAttendance.comments'), style: 'width: 30%' }
      ]
    }
  },
  created () {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    ...mapActions('classAttendance', [
      'fetchTerms',
      'fetchClasses',
      'fetchTeachers',
      'fetchSubjects'
    ]),
    fetchResourceBeforeCreate () {
      this.loadingPreData = true
      this.$store
        .dispatch('classAttendance/dataBeforeCreate')
        .then(() => {
          this.loadingPreData = false
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    async loadTerms ({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.termOptions = null
        let response = await this.fetchTerms()
        this.termOptions = response.data.map(el => ({
          id: el.ac_term_id,
          label: el.term_name
        }))
      }
    },
    async loadClasses ({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.classOptions = null
        let response = await this.fetchClasses({
          ac_term_id: this.model.ac_term_id
        })
        this.classOptions = response.data.map(el => ({
          id: el.class_id,
          label:
            el.class_name +
            ' | ' +
            el.academic_study_time.study_time +
            ' | ' +
            el.academic_study_time.session +
            ' | ' +
            el.teacher.full_name_en
        }))
      }
    },
    fetchData (attributes) {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'classAttendance/fetch',
          Object.assign(
            {},
            this.model,
            { branch_id: this.branch_id },
            attributes
          )
        )
        .then(response => {
          this.model.student_attendance_list = []
          this.loading = false
          this.model.student_attendance_list = response.data.map(el => ({
            att_status: el.att_status,
            comments: el.comments,
            student_name: el.student_name,
            att_status_id: parseInt(el.att_status_id),
            present_status_id: parseInt(el.present_status_id),
            student_att_id: parseInt(el.student_att_id),
            student_id: parseInt(el.student_id)
          }))
        })
        .catch(error => {
          this.model.student_attendance_list = []
          this.loading = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    async save () {
      this.errors = new Errors()
      this.saving = true

      try {
        let response = await this.$store.dispatch(
          'classAttendance/store',
          this.model
        )

        this.$toasted.success(response.message)
      } catch (error) {
        this.$toasted.error(error.message)
        this.errors = new Errors(error.errors)
      }

      this.saving = false
    }
  },
  watch: {
    'model.ac_term_id': function (value) {
      this.model.class_id = null
      this.classOptions = null
      if (value) {
        this.fetchClasses({ ac_term_id: value })
      }
    },
    'model.att_date': function (value) {
      this.fetchingTeacher = true
      this.model.teacher_id = null
      this.$store.commit('classAttendance/SET_TEACHER_OR_SUBJECT', [])
      if (value) {
        this.fetchTeachers({ att_date: value, class_id: this.model.class_id })
          .then(() => {
            this.fetchingTeacher = false
          })
          .catch(error => {
            this.fetchingTeacher = false
            this.$toasted.error(error.message)
          })
      } else {
        this.fetchingTeacher = false
      }
    },
    'model.class_id': function (value) {
      this.fetchingTeacher = true
      this.$store.commit('classAttendance/SET_TEACHER_OR_SUBJECT', [])
      this.model.teacher_id = null
      if (value) {
        this.fetchTeachers({
          att_date: this.model.att_date,
          class_id: value
        })
          .then(() => {
            this.fetchingTeacher = false
          })
          .catch(error => {
            this.fetchingTeacher = false
            this.$toasted.error(error.message)
          })
      } else {
        this.fetchingTeacher = false
      }
    },
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
#table-container {
  min-height: 30vh;
  max-height: 50vh;
  overflow-y: scroll;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
hr {
  border: 1px solid #ececec;
}
</style>
